<template>
  <q-page class="catalog-section-page">
    <div class="">
      <template v-if="section">
        <ProductSectionView :section="section">
          <template #title>
            <h1 class="q-ma-none text-weight-boldest s-font-lg s-font-md-4xl s-font-lg-2xl s-font-xl-2xl">
              {{ section.NAME }}
            </h1>
          </template>
        </ProductSectionView>
      </template>
      <template v-else-if="!isLoading">
        <div class="text-center q-pa-xl">
          <div class="text-h6 text-grey-7">Секция не найдена</div>
          <q-btn
            flat
            color="primary"
            label="На главную"
            to="/"
            class="q-mt-md"
          />
        </div>
      </template>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useCatalogStore } from "@/modules/shop/store/catalog";
import { usePageFrontStore } from "@/stores/page-front";
import { storeToRefs } from "pinia";
import ProductSectionView from "@/components/Shop/ProductSection/Section.vue";
import {useMeta} from "quasar";
import {usePageMeta} from "@/core/store/page-meta";

const route = useRoute();
const catalogStore = useCatalogStore();
const pageFrontStore = usePageFrontStore();

const { sectionsByCode, sections } = storeToRefs(catalogStore);
const { activeSection } = storeToRefs(pageFrontStore);

const sectionCode = computed(() => route.params.sectionCode as string);

const section = computed(() => {
  if (!sectionCode.value) return null;
  return sectionsByCode.value[sectionCode.value] || null;
});

const isLoading = computed(() => sections.value.length === 0);

// Синхронизация активной секции в меню
watch(sectionCode, (code) => {
  if (code) {
    activeSection.value = code;
  }
}, { immediate: true });

const {fillMeta} = usePageMeta()

useMeta(() => {
  return fillMeta({
    title: section.value?.NAME || 'Товары'
  })
})

</script>

<style lang="scss" scoped>
.catalog-section-page {

}
</style>
